<template>
  <div>
    <navbar back fixed bg>
      <span slot="title">案例分享</span>
    </navbar>
    <div class="page-content">
      <!-- <scroller ref="scroller"> -->
      <div class="article-wrapper">
        <h3 class="text-center">{{article.title}}</h3>
        <div class="article-type text-right" >
          <span >【{{article.copyright}}】</span>
          <span>{{article.auditDate}}</span>
        </div>
        <div class="article-txt" v-html="article.content">
        </div>
      </div>
      <div>
        <person :counselor-id="counselorId" :type-list="typeList" @show-modal="show = true"></person>
      </div>
      <!-- </scroller> -->
    </div>
    <modal :show="show" @close-modal="dismiss($event)" class="consultant-dialog" :hide-on-blur="true">
      <div class="page-caption">
        <h3 class="title">预约贷款服务<span class="iconfont pull-right" @click="dismiss($event)">&#xe61b;</span></h3>
        <div class="point"></div>
        <div class="line"></div>
      </div>
      <form class="appointment-wrap" novalidate="novalidate" @submit.prevent="loanReservation">
        <div class="common-style clearfix">
          <div class="pull-left common-padding">
            <label class="label">预&nbsp;约&nbsp;日&nbsp;期：</label>
          </div>
          <div class="pull-right" style="position: relative">
            <input type="text" v-model="selectedDate" autocomplete="off" style="width: 120px" @click="showDatePicker" readonly unselectable="on">
            <span class="iconfont" @click="showDatePicker">&#xe65a;</span>
            <datePicker
              :is-show="isShowDatePicker"
              @select-date="selectDate"
              :end-year="endYear"
              :end-month="endMonth"
              :end-date="endDate"
              :is-limit="true"/>
          </div>
        </div>
        <div class="common-style clearfix">
          <div class="pull-left common-padding">
            <label class="label">预&nbsp;约&nbsp;时&nbsp;间：</label>
          </div>
          <div class="pull-right" style="position: relative">
            <div class="time-wrap pull-left">
              <input type="text" v-model="getStartTime" autocomplete="off" style="width: 55px;text-align:center" @click="showTimePicker" readonly unselectable="on">
            </div>
            <div class="septal-line pull-left"></div>
            <div class="time-wrap pull-left" style="margin-left: 6px">
              <input type="text" v-model="getEndTime" autocomplete="off" style="width: 55px;text-align:center" @click="showTimePicker" readonly unselectable="on">
            </div>
            <span class="iconfont" @click="showTimePicker">&#xe65a;</span>
            <timePicker
              v-if="isShowTimePicker"
              :is-show="isShowTimePicker"
              :start-time="setPropsStartTime()"
              @select-start-time="selectStartTime"
              @select-end-time="selectEndTime"/>
          </div>
        </div>
        <div class="common-style clearfix">
          <div class="pull-left common-padding">
            <label class="label">联&nbsp;系&nbsp;人：</label>
          </div>
          <div class="pull-right">
            <input type="text" v-model="person" autocomplete="off"  style="width: 120px">
          </div>
        </div>
        <div class="common-style clearfix">
          <div class="pull-left common-padding">
            <label class="label">联&nbsp;系&nbsp;电&nbsp;话：</label>
          </div>
          <div class="pull-right">
            <input type="tel" v-model="phone" autocomplete="off" style="width: 120px">
          </div>
        </div>
        <div class="confirm-btn" >
          <p v-if="errmsg" style="font-size:7px;color:red;letter-spacing:2px;margin: 0"><span>{{errmsg}}</span>&nbsp;</p>
          <p v-if="!errmsg" style="font-size:7px;color:#7084a4;letter-spacing:2px;margin: 0;margin-bottom: 11px">我们会在您要求的时间与您联系！</p>
          <button type="submit">确定</button>
        </div>
      </form>
    </modal>
  </div>
</template>

<script>
  import Navbar from '../navbar/navbar'
  // import Scroller from '../scroller/scroller'
  import Person from './person'
  import Modal from '../modal/modal2'
  import DatePicker from '../picker/date'
  import TimePicker from '../picker/time'

  const MONTHRANGE = 3  // 贷款预约月份限制为距今3个月
  export default {
    data () {
      return {
        counselorId: null,
        articleId: null,
        article: {},
        typeList: [],
//        copyRightType: null,
        show: false,
        // 日期
        isShowDatePicker: false,
        isShowTimePicker: false,
        selectedDate: '',
        startTime: null,
        endTime: null,
        endYear: null,
        endMonth: null,
        endDate: null,
        person: '',
        phone: '',
        errmsg: ''
      }
    },
    components: {
      Navbar,
      // Scroller,
      Person,
      Modal,
      DatePicker,
      TimePicker
    },
    created () {
      this.counselorId = this.$route.params.uid
      this.articleId = this.$route.query.id
      this.getLoanTypeArr()
      this._fetchArticleById()

      this.endYear = new Date().getFullYear()
      this.endMonth = new Date().getMonth() + 1 + MONTHRANGE
      this.endDate = new Date().getDate()
      if (this.endMonth > 12) {
        this.endYear += Math.floor(this.endMonth / 12)
        this.endMonth = this.endMonth % 12
      }
    },
    // mounted () {
    //   this.$nextTick(() => {
    //     setTimeout(() => {
    //       this.$refs.scroller.resize()
    //     }, 500)
    //   })
    // },
    watch: {
      selectedDate () {
        this.startTime = null
        this.endTime = null
      }
    },
    computed: {
      getStartTime () {
        return this.startTime && this.startTime + ':00'
      },
      getEndTime () {
        return this.endTime && this.endTime + ':00'
      }
    },
    methods: {
      // 获取贷款类型
      getLoanTypeArr () {
        let vm = this
        this.$ajax({
          url: '/getLoanTypeMap.jhtml',
          params: {
            cityNo: this.$cache.getCity().code
          },
          done (result) {
            vm.typeList = [].concat(result)
          }
        })
      },
      // 根据文章ID获取文章
      _fetchArticleById () {
        let vm = this
        this.$ajax({
          url: '/getArticleInfo.jhtml',
          params: {
            type: '3',
            articleId: this.articleId
          },
          done (result) {
            vm.article = result || {}
//            vm.getCopyRightTag(vm.article.copyright)
          }
        })
      },
      // 获取文章的类型
    /*  getCopyRightTag (copyright) {
        let vm = this
        this.$ajax({
          url: '/getLookupCdeList.jhtml',
          params: {
            typeCode: 20008005,
            cdeCode: copyright
          },
          done (result) {
            vm.copyRightType = result[0].cdeName
          }
        })
      }, */
      setPropsStartTime () {
        let startTime = 1
        if (new Date(this.selectedDate).getTime() > new Date().getTime()) {
          return startTime
        }
        // if (this.startTime === null) {
        //   startTime = new Date().getHours()
        // } else {
        //   startTime = this.startTime
        // }
        startTime = new Date().getHours()
        return startTime
      },
      showDatePicker () {
        // 选择时间不能在选择日期
        if (this.isShowTimePicker) {
          this.isShowDatePicker = false
          return
        }
        this.isShowDatePicker = true
      },
      showTimePicker () {
        if (!this.selectedDate) {
          this.errmsg = '请先选择预约日期'
          return
        }
        this.isShowTimePicker = true
      },
      selectDate (year, month, date) {
        this.isShowDatePicker = false
        this.selectedDate = year + '-' + month + '-' + date
      },
      selectStartTime (startTime) {
        this.startTime = startTime
      },
      selectEndTime (endTime) {
        this.endTime = endTime
        this.isShowTimePicker = false
      },
      // 验证
      validate () {
        if (!this.selectedDate) {
          this.errmsg = '请先选择预约日期'
          return
        }
        if (!this.startTime) {
          this.errmsg = '请选择开始时间'
          return
        }
        if (!this.endTime) {
          this.errmsg = '请选择结束时间'
          return
        }
        if (!this.person || (/\s+/g.test(this.person))) {
          this.errmsg = '联系人不能为空'
          return
        }
        if (this.phone === '') {
          this.errmsg = '手机号不能为空'
          return
        }
        if (!(/^1\d{10}$/.test(this.phone))) {
          this.errmsg = '请输入正确手机号'
          return
        }
        this.errmsg = ''
        return true
      },
      dismiss (e) {
        this.isShowDatePicker = false
        this.isShowTimePicker = false
        this.selectedDate = null
        this.startTime = null
        this.endTime = null
        this.person = ''
        this.phone = ''
        this.errmsg = ''
        this.show = false
      },
      // 贷款预约
      loanReservation (e) {
        if (this.validate()) {
          let vm = this
          this.$ajax({
            url: '/loanReservation.jhtml',
            params: {
              contact: vm.person,
              counselorId: vm.counselorId,
              contactNumber: vm.phone,
              reservationDate: vm.selectedDate,
              startTime: vm.startTime,
              endTime: vm.endTime
            },
            done () {
              vm.dismiss(e)
              vm.$dialog('预约成功！')
            },
            fail (m) {
              vm.errmsg = m
            }
          })
        }
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../common/css/mixmin'
    .page-content
      overflow auto
    .article-wrapper
      margin  px2rem(28) 1em px2rem(35)
      background-color #fff
      border-radius px2rem(10)
      box-shadow 0 px2rem(10) px2rem(30) 0 rgba(188,200,209, 1)
      padding  px2rem(34) px2rem(30) px2rem(28) px2rem(30)
      h3
        margin 0
        color #275482
        font-size px2rem(26)
        line-height px2rem(50)
      .article-type
        font-size px2rem(20)
        color #97a1aa
        margin px2rem(13) 0 px2rem(11) 0
        width 100%
        line-height px2rem(50)
      .article-txt
        font-size px2rem(20)
        color #1a4369
        text-indent 2em
        line-height px2rem(40)
        letter-spacing px2rem(3)
      .article-txt p
        margin 0
</style>



// WEBPACK FOOTER //
// article.vue?4b8d3bed